import { createContext } from 'preact';

const CoreState = createContext({});
// const AuthState = createContext({});
// const ValidationState = createContext({});

export {
    CoreState
};